import { defineStore } from "pinia";
import { dataService } from "@thegetty-private/rad-app-utils";
import { findAndGetAATValue } from "@thegetty-private/linked-data.js";

export const useAatStore = defineStore("aat", {
  state: () => ({
    items: {}
  }),
  actions: {
    async addAat(id) {
      if (this.items[id] != undefined) {
        return;
      }
      try {
        let result = await dataService.getVocabObject(id, "aat");
        if (result != undefined) {
          this.items[id] = {
            id: id,
            value: findAndGetAATValue({
              id: id,
              qualifiers: [result?.data]
            })
          };
        }
      } catch (e) {
        console.error(e);
      }
    }
  },
  getters: {
    getAat(state) {
      return (id) => {
        return state.items[id];
      };
    }
  }
});
